<template>
  <div></div>
  <!--//@*/*
      //    *BCS   App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <!-- <timeout :seconds_to_warn="600" :seconds_to_final="60" v-bind:loginURL="loginURL" v-if="showtimeout"></timeout> -->
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
//import timeout from "./timeout";
export default {
  name: "auth",
  mixins: [bus_common],
  //components: { timeout },
  data() {
    return {
      x: "auth this",
      refreshTimer: null,
      showtimeout: false,
      /*             loginURL: 'https://rpdlogin.org/rpdauth1/?returnURL=http://localhost:5000/'*/
      loginURL:
        "https://rpdportal.org/?returnURL=https://firearmdev.renopdportal.org/",
    };
  },
  mounted() {
    let callback = () => {
      window.location.replace(self.loginURL);
    };
    this.showtimeout = true;
    var self = this;
    this.refreshTimer = window.setTimeout(() => {
      /* alert("did this happen?"); */
      return true;
      if (
        self.$store.state.user != undefined &&
        self.$store.state.user.auth == true
      ) {
        var form = { token: self.$store.state.user.token };

        this.$store
          .dispatch("valtoken", form)
          .then((data) => {
            console.log("Valid");
            var user = {
              email: data.email,
              date: this.$moment(data.date),
              auth: true,
              token: form.token,
              roles: data.roles,
              rpduserId: data.rpduserId,
              local_roleId: data.local_roleId,
            };

            this.$store.commit("setUser", user);
          })
          .catch((error) => {
            if (error.response) {
              self.show_loader(false);
              this.$swal({
                title: "Login Error!",
                text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#283593",
                timer: 3000,
                didClose: callback,
              });
            }
          });
      }
    }, 300000);
    //Check token evey 5m
  },
  created() {
    let callback = () => {
      window.location.replace(self.loginURL);
    };
    var qry_token = this.$route.query.token;
    var user_token = this.$store.state.user.token;
    var self = this;

    if (qry_token == undefined && user_token == "") {
      var self = this;
      self.show_loader(false);
      this.$swal({
        title: "Login Error!",
        text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#283593",
        timer: 3000,
        didClose: callback,
      });
    } else {
      //validate toke, query takes precendent
      var token = qry_token != undefined ? qry_token : user_token;

      var form = {
        token: token,
      };

      var self = this;
      /*                this.$axios.post('api/valtoken', form)*/
      this.$store
        .dispatch("valtoken", form)
        .then((data) => {
          //self.mrbreakpoint(data);
          if (data.email == null) {
            window.open(self.loginURL, "_self");
            return true;
          }

          console.log("valid");
          var user = {
            email: data.email,
            date: this.$moment(data.date),
            auth: true,
            token: form.token,
            roles: data.roles,
            rpduserId: data.rpduserId,
            local_roleId: data.local_roleId,
          };
          self.$store.commit("setUser", user);
          console.log("setuser");
          //no roles then rediect
          // if (
          //   user.roles.indexOf("dev-dev") == -1 &&
          //   user.roles.indexOf("trfst-canlogin") == -1
          // ) {
          //   self.show_loader(false);
          //   this.$swal({
          //     title: "Login Needed",
          //     text: "You do no have the needed role to use this app.",
          //     icon: "warning",
          //     confirmButtonText: "OK",
          //     confirmButtonColor: "#283593",
          //     timer: 3000,
          //     didClose: callback,
          //   });
          // }
          if (user.email == null) {
            self.show_loader(false);
            this.$swal({
              title: "Login Needed",
              text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
              icon: "warning",
              confirmButtonText: "OK",
              confirmButtonColor: "#283593",
              timer: 3000,
              didClose: callback,
            });
          }

          this.$store.commit("setUser", user);
        })
        .catch((error) => {
          if (error.response) {
            self.show_loader(false);
            this.$swal({
              title: "Login Needed",
              text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
              icon: "warning",
              confirmButtonText: "OK",
              confirmButtonColor: "#283593",
              timer: 3000,
              didClose: callback,
            });
          }
        });
    }
  },
};
</script>
